<template>
  <main class="main allergens-page">
    <section>
      <div class="container">
        <h1 style="font-size: 2.625rem;">
          Cookie policy
        </h1>
        <div ref="consent"></div>          
      </div>
    </section>
  </main>
</template>

<script>
export default {
  name: "CookiePolicy",
  mounted() {
    this.$cookiebot.consentPage({
      async: true,
      locale: 'en', // tip: replace 'en' with this.$i18n.locale when using vue-i18n
      ref: this.$refs.consent // Must be a Vue ref or html element
    })      
  },
};
</script>

<style lang="scss"></style>
